import Grid from '@blocks/Grid'
import Input from '@blocks/Input'
import Select from '@blocks/Select'
import React from 'react'
import { OptionsType } from 'react-select'

export default function PatronageInputs({ id, number, organization, organizations }: Props) {
    const organizationOption = organization ? { value: organization?.id.toString(), label: organization?.name } : undefined
    return (
        <Grid columns="2">
            <Select id={`organization-${id}`} value={organizationOption} name={`patronages[${id}][organization_id]`} label="Organization" options={organizations} required />
            <Input id={`number-${id}`} defaultValue={number} name={`patronages[${id}][number]`} label="Number" placeholder="2021/048" required />   
        </Grid>
    )
}

type Props = PartialExcept<Interfaces.Patronage, "id"> & {
    organizations?: OptionsType<{ label: string; value: string; }>
}